"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RfidAntennaStates = exports.RfidAntennaActions = void 0;
const events_1 = require("events");
const MessageParser_1 = require("./MessageParser");
const ISerialPort_1 = require("./ISerialPort");
var RfidAntennaActions;
(function (RfidAntennaActions) {
    RfidAntennaActions["Picked"] = "picked";
    RfidAntennaActions["Placed"] = "placed";
})(RfidAntennaActions = exports.RfidAntennaActions || (exports.RfidAntennaActions = {}));
var RfidAntennaStates;
(function (RfidAntennaStates) {
    RfidAntennaStates[RfidAntennaStates["PLACED"] = 0] = "PLACED";
    RfidAntennaStates[RfidAntennaStates["PICKED"] = 1] = "PICKED";
})(RfidAntennaStates = exports.RfidAntennaStates || (exports.RfidAntennaStates = {}));
const COMMAND_TAG_NUMBERS_REGEX = /^([ \t]*d\d{3}){4}$/;
class RfidAntenna extends events_1.EventEmitter {
    constructor(serialPort, address) {
        super();
        this.serialPort = serialPort;
        this.address = address;
        this.eventEmitter = new events_1.EventEmitter();
        this.initStream();
    }
    getPlacedTags() {
        return __awaiter(this, void 0, void 0, function* () {
            const address = this.address.toString().padStart(3, '0');
            this.serialPort.sendMessage(`X${address}B[]`);
            const cmdStr = yield this.waitForResponseStatus();
            const cmdStrTrimmed = cmdStr.replace(/[ \t]{2,}/g, ' ').trim();
            const tagParts = cmdStrTrimmed.split(' ');
            return tagParts
                .map((x) => x.substr(1))
                .map((x) => parseInt(x))
                .filter((x) => x !== 0);
        });
    }
    initStream() {
        this.serialPort.on(ISerialPort_1.SerialPortEvent.MESSAGE, (message) => {
            try {
                const cmd = MessageParser_1.parseMessage(message);
                if (cmd.type === 'antenna') {
                    // tag was placed or put
                    if (cmd.command === 'PU') {
                        this.state = RfidAntennaStates.PICKED;
                    }
                    else if (cmd.command === 'PB') {
                        this.state = RfidAntennaStates.PLACED;
                    }
                    this.lastTagNumber = cmd.tagIndex;
                }
                else if (cmd.type === MessageParser_1.CommandType.XTALK
                    && cmd.address === this.address
                    && cmd.format === MessageParser_1.FormatType.SHORT) {
                    // from where tag was placed or put
                    if (cmd.command === '1') {
                        this.handlePicked(this.lastTagNumber);
                    }
                    else if (cmd.command === '0') {
                        this.handlePlaced(this.lastTagNumber);
                    }
                }
                else if (cmd.type === MessageParser_1.CommandType.XTALK
                    && cmd.format === MessageParser_1.FormatType.LONG
                    && cmd.address === this.address
                    && cmd.command.match(COMMAND_TAG_NUMBERS_REGEX)) {
                    this.handleState(cmd.command);
                }
            }
            catch (error) {
                if (error instanceof Error
                    && !(error instanceof MessageParser_1.InvalidArgumentError)
                    && !(error instanceof MessageParser_1.UnknownCommandError)) {
                    console.error(error.message); // eslint-disable-line no-console
                }
            }
        });
    }
    handlePicked(tagNumber) {
        this.emit(RfidAntennaActions.Picked, tagNumber);
    }
    handlePlaced(tagNumber) {
        this.emit(RfidAntennaActions.Placed, tagNumber);
    }
    handleState(command) {
        this.eventEmitter.emit('status_received', command);
    }
    waitForResponseStatus() {
        return new Promise((resolve) => {
            this.eventEmitter.once('status_received', resolve);
        });
    }
}
exports.default = RfidAntenna;
//# sourceMappingURL=RfidAntennaTag.js.map